import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid rgba(29, 29, 29, 0.1);
  border-radius: 24px;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 0 20px 20px 20px;
  width: 100%;
  flex-grow: 1;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Image = styled.img`
  border-radius: 24px;
  width: 100%;
  height: 280px;
  object-fit: cover;
`;

export const Title = styled.h4`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
  color: rgba(29, 29, 29, 0.85);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  white-space: normal;
  text-align: left;
  letter-spacing: -0.01em;
`;

export const SubTitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: rgba(29, 29, 29, 0.5);
  margin-top: 8px;
  margin-bottom: 20px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  white-space: normal;
  text-align: left;
`;

export const ViewContent = styled.a`
  margin-top: auto;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #ff6030;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;

  &::after {
    content: "";
    width: 18px;
    min-width: 18px;
    height: 18px;
    min-height: 18px;
    background-image: url(/images/icons/arrow-top-right.svg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;
